// Required to for testimonial slider fix
window.addEventListener('load', function() {
    window.dispatchEvent(new Event('resize'));
});

// Subscription price update on variant change
const subPriceUpdate = () => {
    document.addEventListener('theme:variant:change', (e) => {
        const productForm = e.target.querySelector('.product-single .product__block[data-form-wrapper]');

        if (!productForm) return;
        
        // const quantityInput = productForm.querySelector('[name="quantity"]');
        // const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        const oneTimeEl = productForm.querySelectorAll('[data-one-time-price]');
        const discountEl = productForm.querySelectorAll('[data-discount-price]');
        const variantPrice = e.detail.variant.price;
        const discountPrice = e.detail.variant.selling_plan_allocations[0].per_delivery_price;

        const formatPrice = (val) => {
            const formatted = (val / 100).toLocaleString('en-US', {
                style: 'currency', 
                currency: 'USD'
            });
            return formatted.replace('$', '$ ');
        };

        oneTimeEl.forEach(priceEl => {
            // let total = variantPrice * quantity;
            priceEl.innerText = formatPrice(variantPrice);
        });

        discountEl.forEach(priceEl => {
            // let total = discountPrice * quantity;
            priceEl.innerText = formatPrice(discountPrice);
        });
    });
};
document.addEventListener("DOMContentLoaded", subPriceUpdate);
document.addEventListener('shopify:section:load', subPriceUpdate);

// Tabs toggle
const tabsToggle = () => {
    const tabCtrs = document.querySelectorAll('.column-item__content-tabs');
    tabCtrs.forEach(ctr => {
        const tabs = ctr.querySelectorAll('.column-item__tab');
        const tabsBody = ctr.querySelectorAll('.column-item__body');
        if(tabs[0]) {
            tabs[0].classList.add('tab-active');
        }
        if(tabsBody[0]) {
            tabsBody[0].classList.add('tab-active');
        }
        function activeClass(tabId) {
            tabsBody.forEach(body => {
                if (body.getAttribute('data-tab-id') === tabId) {
                    body.classList.add('tab-active');
                } else {
                    body.classList.remove('tab-active');
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-tab-id') === tabId) {
                    tab.classList.add('tab-active');
                } else {
                    tab.classList.remove('tab-active');
                }
            });
        }
        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                const tabId = event.currentTarget.getAttribute('data-tab-id');
                activeClass(tabId);
            });
        });
    });
};
function initTabsToggle() {
    if (document.querySelector('.column-item__content-tabs')) {
        tabsToggle();
    }
}
document.addEventListener("DOMContentLoaded", initTabsToggle);
document.addEventListener('shopify:section:load', initTabsToggle);